import React from "react";
import { DOCK_MOTION } from "../components/ChatBot/flerpieDock";
import { buttonClass, IconButton } from "../components/ui/Button";
import { Menu } from "../components/ui/Menu";
import { Pager } from "../components/ui/Pager";
import { Appear } from "../components/ui/Appear";

const ownerIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"/></svg>
);
const projectIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.825a2 2 0 0 1-1.991-1.819l-.637-7a1.99 1.99 0 0 1 .342-1.31L.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3zm-8.322.12C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139z"/></svg>
);
const flagIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M14.778.085A.5.5 0 0 1 15 .5V8a.5.5 0 0 1-.314.464L14.5 8l.186.464-.003.001-.006.003-.023.009a12.435 12.435 0 0 1-.397.15c-.264.095-.631.223-1.047.35-.816.252-1.879.523-2.71.523-.847 0-1.548-.28-2.158-.525l-.028-.01C7.68 8.71 7.14 8.5 6.5 8.5c-.7 0-1.638.23-2.437.477A19.626 19.626 0 0 0 3 9.342V15.5a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 1 0v.282c.226-.079.496-.17.79-.26C4.606.272 5.67 0 6.5 0c.84 0 1.524.277 2.121.519l.043.018C9.286.788 9.828 1 10.5 1c.7 0 1.638-.23 2.437-.477a19.587 19.587 0 0 0 1.349-.476l.019-.007.004-.002h.001"/></svg>
);
const clearIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M12.354 4.354a.5.5 0 0 0-.708-.708L5 10.293 1.854 7.146a.5.5 0 1 0-.708.708l3.5 3.5a.5.5 0 0 0 .708 0l7-7zm-4.208 7-.896-.897.707-.707.543.543 6.646-6.647a.5.5 0 0 1 .708.708l-7 7a.5.5 0 0 1-.708 0z"/></svg>
);

const BottomBar = ({
  // Pagination
  table,
  totalResults,
  // Cart
  cartSize,
  onCartClick,
  // Actions
  hasSelectedDrones,
  onOwnerClick,
  onProjectClick,
  onFlagAddClick,
  onFlagRemoveClick,
  // Mode
  isPortrait,
}) => {
  const { pageIndex, pageSize } = table.getState().pagination;
  const totalPages = table.getPageCount();

  if (isPortrait) {
    // Mobile bottom bar
    return (
      <div className={`fixed bottom-0 left-[var(--flerpie-dock,0px)] right-0 transition-[left] ${DOCK_MOTION} bg-gray-900/95 backdrop-blur-md border-t border-gray-700 z-40`}>
        <div className="flex items-center justify-between px-3 py-2 max-w-lg mx-auto">
          {/* Pagination */}
          <Pager
            size="mini"
            label="Pages of drones"
            page={pageIndex}
            pageCount={totalPages}
            onPage={(i) => table.setPageIndex(i)}
            showSingle
          />

          {/* Cart Button */}
          <button
            onClick={onCartClick}
            className={buttonClass(cartSize > 0 ? "filled" : "tonal", "md")}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
              <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
            </svg>
            <Appear show={cartSize > 0}>{cartSize}</Appear>
          </button>

          {/* Actions Menu */}
          <Menu
            label="Actions"
            align="end"
            disabled={!hasSelectedDrones}
            items={[
              { label: "Assign Owner", icon: ownerIcon, onSelect: onOwnerClick },
              { label: "Assign Project", icon: projectIcon, onSelect: onProjectClick },
              {
                items: [
                  { label: "Add Flag", icon: flagIcon, onSelect: onFlagAddClick },
                  { label: "Clear Flags", icon: clearIcon, onSelect: onFlagRemoveClick },
                ],
              },
            ]}
            trigger={(props) => (
              <IconButton {...props} label="Actions">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
                </svg>
              </IconButton>
            )}
          />
        </div>
      </div>
    );
  }

  // Desktop bottom bar
  return (
    <div className="flex items-center justify-between px-4 py-3">
      {/* Pagination */}
      <Pager
        label="Pages of drones"
        page={pageIndex}
        pageCount={totalPages}
        onPage={(i) => table.setPageIndex(i)}
        total={totalResults}
        pageSize={pageSize}
        showSingle
      />

      {/* Actions - always visible, grayed out when no selection */}
      <div className="flex items-center gap-2">
        <button
          onClick={onOwnerClick}
          disabled={!hasSelectedDrones}
          className={buttonClass("tonal", "sm")}
        >
          Owner
        </button>
        <button
          onClick={onProjectClick}
          disabled={!hasSelectedDrones}
          className={buttonClass("tonal", "sm")}
        >
          Project
        </button>
        <button
          onClick={onFlagAddClick}
          disabled={!hasSelectedDrones}
          className={buttonClass("tonal", "sm")}
        >
          Flag+
        </button>
        <button
          onClick={onFlagRemoveClick}
          disabled={!hasSelectedDrones}
          className={buttonClass("tonal", "sm")}
        >
          Flag-
        </button>
      </div>
    </div>
  );
};

export default BottomBar;
